
import axios from 'axios';
import BaseUrl from '../../utils/api.js';

export default class PositionService {

    static getPositionListResult(CompanyCode, list, ActionType) {

        var data={
            CompanyCode: CompanyCode,
            list: list,
            ActionType:ActionType
        }  
        return axios.post( BaseUrl+'Position', data);
    }

    static SavePosition(CompanyCode, list, ActionType, email) {

        var data={
            CompanyCode: CompanyCode,
            list: list,
            ActionType
        }  
        return axios.post(BaseUrl+'SavePosition?email='+email, data);
    }
}



// WEBPACK FOOTER //
// ./src/Services/PositionService/positionService.js